import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EducationOverlayComponent } from './education-overlay.component';
import { EducationCourseListModule } from '@lists/_index';

@NgModule({
  imports: [CommonModule, EducationCourseListModule, EducationOverlayComponent],
  exports: [EducationOverlayComponent],
})
export class EducationOverlayModule {}
